import { render, staticRenderFns } from "./Grocer.vue?vue&type=template&id=f1537e20&scoped=true"
import script from "./Grocer.vue?vue&type=script&lang=js"
export * from "./Grocer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1537e20",
  null
  
)

export default component.exports